import { render, staticRenderFns } from "./WineShipmentsManagement.vue?vue&type=template&id=7f31de36&scoped=true&"
import script from "./WineShipmentsManagement.vue?vue&type=script&lang=ts&"
export * from "./WineShipmentsManagement.vue?vue&type=script&lang=ts&"
import style0 from "./WineShipmentsManagement.vue?vue&type=style&index=0&id=7f31de36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f31de36",
  null
  
)

export default component.exports